<template>
	<div class="ao-checkboxes">
		<div
			v-if="inputTitle"
			class="ao-h4 mb-1"
		>
			{{ inputTitle }}
		</div>
		<v-text-field
			v-if="isSearch"
			v-model="query"
			clearable
			color="primary"
			placeholder="Поиск"
			variant="underlined"
			class="text-field-font-x-small customize-input-icons-small mb-3"
			density="compact"
			clear-icon="mdi-close"
			hide-details
			@input="handleInput"
		/>
		<ao-btn
			v-if="isShowSelectAll"
			size="small"
			@click="$emit('update:checkAll')"
		>
			{{ $t('Select all') }}
		</ao-btn>

		<div :class="{'scrollable': scrollable}">
			<ao-checkbox
				v-for="item in sortedItems"
				:key="getKey(item)"
				class="mb-1"
				:model-value="modelValue.includes(getKey(item))"
				color="secondary"
				:background="background"
				density="compact"
				@update:modelValue="update(item)"
			>
				<span>{{ getTitle(item) }}</span>
			</ao-checkbox>
		</div>
	</div>
</template>

<script>
import { getAlternateKeyboardLayout } from '@/helpers/stringHelper'

export default {
	name: 'AoCheckboxes',

	components: {},

	props: {
		modelValue: {
			type: Array,
			default: () => [],
		},
		items: {
			type: Array,
		},
		itemTitle: {
			type: String,
		},
		itemValue: {
			type: String,
		},
		returnObject: Boolean,
		isShowSelectAll: Boolean,
		isSearch: {
			type: Boolean,
			default: true,
		},
		background: {
			type: Boolean,
			default: true,
		},
		inputTitle: {
			type: String,
			default: null,
		},
		scrollable: {
			type: Boolean,
			default: false,
		},
		isSorted: {
			type: Boolean,
			default: true,
		},
		sortCompareCallback: {
			type: Function,
			default: null,
		},
	},

	emits: ['update:modelValue', 'update:checkAll'],

	data: () => ({
		query: '',
	}),

	computed: {
		filteredItems() {
			if (!this.query) {
				return this.items
			}

			return this.items.filter((item) => {
				let isCurrentKeyboardLayoutResult = this.getTitle(item)
					.toLowerCase()
					.includes(this.query.toLowerCase())
				if (isCurrentKeyboardLayoutResult) {
					return true
				} else {
					return this.getTitle(item)
						.toLowerCase()
						.includes(getAlternateKeyboardLayout(this.query).toLowerCase())
				}
			})
		},
		sortedItems() {
			let sortedItems = [...this.filteredItems]
			if (this.isSorted) {
				const compareCallback = this.sortCompareCallback || ((a, b) => {
					if (typeof a === 'object' && typeof b === 'object') {
						if (a[this.itemTitle] === b[this.itemTitle]) return 0
						return a[this.itemTitle] > b[this.itemTitle] ? 1 : -1
					} else {
						if (a === b) return 0
						return a > b ? 1 : -1
					}
				})
				sortedItems.sort(compareCallback)
			}

			return sortedItems
		},
	},

	methods: {
		itemIsPrimitive(item) {
			return ['string', 'number', 'bigint', 'undefined', 'boolean', 'symbol', 'null'].includes(item)
		},

		handleInput() {},

		update(item) {
			const copySelected = [...this.modelValue]
			let clickedKey = this.itemIsPrimitive(item) ? item : this.getKey(item)

			let index = copySelected.indexOf(clickedKey)
			if (index > -1) {
				copySelected.splice(index, 1)
			} else {
				copySelected.push(clickedKey)
			}

			this.$emit('update:modelValue', copySelected)
		},

		getKey(item) {
			return item?.[this.itemValue] ? item[this.itemValue] : item
		},

		getTitle(item) {
			if (!item) {
				return ''
			}

			return item?.[this.itemTitle] ?? item
		},
	},
}
</script>

<style lang="scss">
.ao-checkboxes {
	width: 100%;
	.scrollable {
		max-height: 164px;
		overflow-y: auto;
	}
}
</style>
